import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Switch from '../../common/Switch/Switch';

import { StyledStatsSwitcher } from './styles/StyledStatsSwitcher';


class StatsSwitcher extends Component {
  render() {
    const { showDateSwitch, statsSwitch, dateSwitch, statsCheck, dateChecked } = this.props;

    return (
      <StyledStatsSwitcher>
        <table>
          <tbody>
            <tr>
              <td className="tb-office-stats-left">
                Průměrná doba čekání
              </td>
              <td className="tb-office-stats-switch">
                <Switch 
                  id='stats-switch-1'
                  isChecked={statsCheck}
                  onChangeHandle={statsSwitch}
                />
              </td>
              <td className="tb-office-stats-right">
                Obsloužených klientů
              </td>
            </tr>
            { showDateSwitch &&
              <tr>
                <td className="tb-office-stats-left">
                  Rok
                </td>
                <td className="tb-office-stats-switch">
                  <Switch 
                    id='stats-switch-2'
                    isChecked={dateChecked}
                    onChangeHandle={dateSwitch}
                  />
                </td>
                <td className="tb-office-stats-right">
                  Aktuální měsíc
                </td>
              </tr>
            }
          </tbody>
        </table>
      </StyledStatsSwitcher>
    );
  }
}


StatsSwitcher.propTypes = {
  showDateSwitch: PropTypes.bool.isRequired,
  statsSwitch: PropTypes.func.isRequired,
  dateSwitch: PropTypes.func.isRequired,
  statsCheck: PropTypes.bool.isRequired,
  dateChecked: PropTypes.bool.isRequired,
};


export default StatsSwitcher;